module.exports = __webpack_public_path__ + "static/media/cardboard box.8db7b772.png";